// /constants/healthEndpoints.js\


export const MARKET_OPTIONS = [
  { value: "3592556", label: "CH" },
  { value: "4091918", label: "PT" },
  { value: "3547573", label: "UK" },
];

export const ACCOUNT_CODES = {
  3592556: "CH",
  4091918: "PT",
  3403952: "US",
  3497361: "DE",
  3403951: "CH",
  6398176: "AT",
  3547573 : "UK",
  3702667 : "AU",
};

export const SKIP_NAVIGATION_ALERTS = [
  'AZZ',
  'BZZ'
];

/**
 * Roll-up of every live market, used by the global view.
 *
 * Fallback origin for the nerdlet only, where there is no CloudFront in front
 * of the app. The nerdlet runs on New Relic's origin, so it cannot use a
 * same-origin path and must name the dashboard origin explicitly — which then
 * has to be in the proxy's ALLOWED_ORIGINS before it can read either endpoint.
 */
const DASHBOARD_ORIGIN = "https://d355lxof9peey7.cloudfront.net";

/**
 * Key the standalone entry (src/main.jsx) sets on globalThis. Never set inside
 * a nerdpack, so its presence is the signal that this is the standalone build —
 * served from its own origin behind CloudFront (or the vite dev server).
 */
export const STANDALONE_GLOBAL = "__healthDashboardStandalone";

/**
 * Same-origin (relative) for the standalone build, absolute for the nerdlet.
 *
 * The standalone build is always served behind its own CloudFront (prod,
 * non-prod, or the vite dev server on localhost), which routes these paths to
 * the proxy. Requesting them relative keeps every deployment same-origin and
 * needs no CORS — and, crucially, points each deployment at its OWN backend
 * rather than a single hardcoded one. The nerdlet has no such origin, so it
 * falls back to the absolute dashboard origin.
 *
 * Resolved lazily (per call) because the standalone flag is set at runtime by
 * the entry point, after this module is imported.
 */
const at = (path) => {
  const scope = typeof globalThis !== "undefined" ? globalThis : undefined;
  const isStandalone = Boolean(scope && scope[STANDALONE_GLOBAL]);
  return isStandalone ? path : `${DASHBOARD_ORIGIN}${path}`;
};

/** Live aggregation: the proxy fans out to every market on demand (~800ms). */
export const getGlobalSummaryUrl = () => at("/api/global");

/**
 * The same roll-up written to S3 on a schedule. A plain object served by the
 * existing bucket behaviour, so it needs no Lambda, no proxy route and no
 * shared secret — which is also why it keeps working when either is down.
 */
export const getGlobalSummarySnapshotUrl = () => at("/global-summary.json");

export function getApiPaths(accountId) {
  const code = ACCOUNT_CODES[accountId] || "CH"; // default fallback
  let code2 = code;
  if(code === "CH") {
    code2 =  "CH2"; // secondary code
  }
  return {
    STORES_VIEW: `/${code2}/RMPWidgetStoresView`,
    SERVICES_VIEW: `/${code2}/RMPWidgetServicesView`,
    MARKET_SERVICE_HEALTH: `/${code}/MarketServiceHealth`,
    MARKET_STORE_HEALTH: `/${code}/MarketStoreHealth`,
    // Daily service health, one point per day. Currently a fixed 30-day window
    // with no range parameter, which is what bounds the chart's ranges.
    TREND_VIEW: `/${code}/MarketServiceHealth`,
    DIGITAL_ORDERING: `/${code}/DigitalOrdering`,
    SESAME: `/${code}/Sesame`,
    EPROD: `/${code}/eProd`,
    MY_STORE: `/${code}/MyStore`,
    AI_API: `/${code}/insights`,
  };
}

// export const API_PATHS = {
//   STORES_VIEW: "/CH/RMPWidgetStoresView",
//   SERVICES_VIEW: "/CH/RMPWidgetServicesView",
// };


// const MARKET_SERVICE_HEALTH = "/CH/MarketServiceHealth";
// const MARKET_STORE_HEALTH = "/CH/MarketStoreHealth";
// const DIGITAL_ORDERING = "/CH/DigitalOrdering";
// const SESAME = "/CH/Sesame";
// const EPROD = "/CH/eProd";
// const MY_STORE = "/CH/MyStore";

// const HEALTH_ENDPOINTS = {
//   MARKET_SERVICE_HEALTH,
//   MARKET_STORE_HEALTH,
//   DIGITAL_ORDERING,
//   SESAME,
//   EPROD,
//   MY_STORE,
// };

// // Human-friendly titles for charts/UI
// const HEALTH_TITLES = {
//   MARKET_SERVICE_HEALTH: "Market Service Health",
//   MARKET_STORE_HEALTH: "Market Store Health",
//   DIGITAL_ORDERING: "Digital Ordering",
//   SESAME: "Sesame",
//   EPROD: "eProd",
//   MY_STORE: "My Store",
// };

// export {
//   MARKET_SERVICE_HEALTH,
//   MARKET_STORE_HEALTH,
//   DIGITAL_ORDERING,
//   SESAME,
//   EPROD,
//   MY_STORE,
//   HEALTH_ENDPOINTS,
//   HEALTH_TITLES,
// };

// export default HEALTH_ENDPOINTS;
